export const GRADE = "curriculum_id";
export const MODULE = "module_id";
export const SUB_MODULE = "sub_module_id";
